const sl = {
    common: {
        history: "zgodovinska različica"
    }
};
export default sl;



// WEBPACK FOOTER //
// ./src/i18n/langs/si.js